import module from 'usuario/module.js'
import template from './template.html'

export class UsuarioActivarComponent {

  usuarioId
  invitacionActiva
  onClose
  activado = false
  activando = false

  constructor (AppActivarUsuario) {
    this.AppActivarUsuario = AppActivarUsuario
  }

  activarUsuario () {

    if (this.activando) return

    this.activando = true
    this.error = null

    this.AppActivarUsuario.get(this.usuarioId)
      .then(() => (this.activado = true))
      .catch(() => (this.error = error.data || error))
      .finally(() => (this.activando = false))
  }

  cerrar () {
    this.onClose({$event: {detail: this.activado}})
  }
}

module.component('usuarioActivar', {
  controller: UsuarioActivarComponent,
  template,
  bindings: {
    usuarioId: '<',
    correo: '<',
    invitacionActiva: '<',
    onClose: '&',
  }
})



// WEBPACK FOOTER //
// ./src/usuario/components/activar/component.js